<template>
  <div>
    <div class="row">
      <div class="col-md-9">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{Dates(datas.created_at)}}
          <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
            class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        </h4>
      </div>
      <div class="col-md-3 end">
        <router-link class="btn btn-danger" :to="{ path: '/salary/index' }">
          <button type="button" class="closebutton">
            <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">


      <div class="col-md-3 topheader">
        <span>
          <label>Склад</label>
          <v-select :clearable="false" class="form-control-sm required md-input" :options="skladlist"
            :disabled="skladhave" v-model="datas.sklad_id" :reduce="name => name.id" label="name">
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>Маьлумот йўқ</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Сумма</label><br>
          {{ datas.summa | numFormat }}
        </span>
      </div>
      <!-- <div class="col-md-2 topheader">
        <span>
          <label>{{$t('Сони')}}</label><br>
          {{ datas.count_all | numFormat }}
        </span>
      </div> -->
      <div class="col-md-4 topheader">
        <span>
          <label for="">Комментарий</label>
          <input :disabled="changedisabled" type="text" class="input100" v-model="datas.comment">
        </span>
      </div>
      <div class="col-md-2">
        <button v-if="changedisabled==false" class="addrow btn btn-primary" type="button" @click="Download()">
          {{$t('Юклаш')}}
        </button>
      </div>
    </div>
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column0">№</th>
                <th class="column3">Ходим</th>
                <th class="column2">Сумма</th>
                <th class="column0"></th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <div style="overflow-y: scroll;height: 62vh!important;">
                <tr v-for="(item, index) in datas.table" :key="index">
                  <td class="column0">{{ index + 1 }}</td>
                  <td class="column3">
                    <v-select class="form-control-sm md-input" :options="userlist" @input="Userchange(index)"
                      v-model="item.user_id" :reduce="name => name.id" label="name" :clearable="false">
                    </v-select>
                  </td>
                  <td class="column2">
                    <vue-numeric :disabled="changedisabled" separator="space" v-model="item.summa" @change="Summa()"
                      style="text-align: right;" class="table-input" v-bind:precision="2"></vue-numeric>
                  </td>
                  <td class="column0">
                    <a v-if="changedisabled==false" href="javascript:void(0)" class="circul trash"
                      @click="Trashitem(index)">
                      <b-icon icon="trash"></b-icon>
                    </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="row">
      <div class="col-md-12 end formbottom">
        <button v-if="changedisabled==false" class="addrow btn btn-primary" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button :disabled="changedisabled" class="btn btn-success" type="button" @click="Savedokument('save')">
          {{ $t("Сақлаш") }}
        </button>
        <button :disabled="changedisabled" type="button" class="mybtn btn saved" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }} <sup>crl+enter</sup>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  export default {
    name: "SalaryForm",
    mixins: [print],
    data() {
      return {
        userlist: [],
        sklad: "",
        skladlist: [],
      };
    },
    props: ["datas", "errors"],
    created() {
      let self = this;
      self.$root.$refs.salary = self;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
    },
    mounted: function () {
      let self = this;
      setTimeout(() => {
        self.Focus();
        self.Userlist();
        self.SetRule('/salary/index');
      }, 100);
    },
    methods: {
      Userlist() {
        let self = this;
        axios
          .get("api/v1/staff")
          .then(function (response) {
            self.userlist = response.data;
          });
      },
      Download() {
        let self = this;
        axios
          .get("api/v1/staff/")
          .then(function (response) {
            var tt = [];
            response.data.forEach(function (item, value) {
              if (item.sklad_id == self.datas.sklad_id) {
                tt = self.datas.table.filter(row => {
                  return row.user_id == item.id;
                });
                if (tt.length == 0) {
                  self.datas.table.push({
                    user_id: item.id,
                    doc_id: 0,
                    summa: item.salary,
                  });
                }
              }
            });
            setTimeout(() => {
              self.Summa();
            }, 100);
          });
      },
      Summa() {
        this.datas.summa = 0;
        let self = this;
        this.datas.table.forEach(function (key, value) {
          self.datas.summa += parseFloat(key.summa);
        });
      },
      Userchange(index) {
        if (this.changedisabled == false) {
          let self = this;
          var item = self.datas.table[index];
          item.summa = 0;
          axios({
            method: "get",
            url: "api/v1/staff/id/" + item.user_id,
          }).then(function (response) {
            item.summa = response.data.salary;
            setTimeout(() => {
              self.Summa();
            }, 100);
          });
        }
      },
      Focus() {
        $(".vs__search")
          .eq(1)
          .focus();
      },
      Selectbase(index) {
        this.$store.state.selected_index = index;
      },
      Addtable() {
        this.datas.table.push({
          user_id: 0,
          doc_id: 0,
          summa: 0,
        });
        this.Tablefocus();
      },
      Addtableindex(index) {
        if (this.datas.table.length == index + 1) {
          this.datas.table.push({
            user_id: 0,
            doc_id: 0,
            summa: 0,
          });
        }
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.table.splice(index, 1);
          this.Summa();
        }
      },
      Savedokument(type = 'default') {
        let self = this;
        // if (self.rule.open == true) {
          if (this.$route.path == "/salary/create") {
            var methods = "post";
            var action = "api/v1/salary";
          } else {
            var methods = "patch";
            var action = "api/v1/salary/id/" + self.$route.params.id;
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            if (type == 'save') {
              self.$router.push({ path: "/salary/update/" + response.data.id });
            } else {
              self.$router.push({ name: "Маош хисоблаш" });
            }
          });
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
</style>